module.exports = __webpack_public_path__ + "img/error.ae394fdf.png";